module.exports = {
  printers: {
    host: process.env.PRINTERS_HOST,
  },
  auth: {
    issuer: process.env.AUTH_ISSUER,
    clientId: process.env.AUTH_CLIENT_ID,
  },
};



// WEBPACK FOOTER //
// ./src/vue.config.js